import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // If initial session/user information is still loading
  if (loading) { 
    return <div className="flex justify-center items-center h-screen"><p>Authenticating...</p></div>;
  }

  // If done loading and there is no user, redirect to auth.
  if (!user) { // No need to check loading here, as it's false if we reach this point
    console.log('ProtectedRoute: No user, redirecting to auth.');
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // The profileCompletionRequired logic is removed as profile is created at signup.

  // Optional: Role-based access
  if (allowedRoles && user.user_metadata?.role && !allowedRoles.includes(user.user_metadata.role)) {
    console.log(`ProtectedRoute: Role ${user.user_metadata.role} not allowed for this route. Redirecting.`);
    return <Navigate to="/unauthorized" replace />; // Ensure you have an /unauthorized page or redirect to home
  }

  // If all checks pass (user is authenticated and, if roles provided, has an allowed role), render the child component.
  return <Outlet />;
};

export default ProtectedRoute; 